export default __webpack_public_path__ + "static/media/register3.8484dff1.jpg";